module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"paymentReceived":" La tua prenotazione del {date} è stata ANNULLATA!"}}')
  delete Component.options._Ctor
}
